import { DEV, ParentComponent } from 'solid-js'
import { Toaster } from 'solid-toast'
import TheCornerWidget from './components/CornerWidget/TheCornerWidget'
import ColorPicker from './components/Debug/ColorPicker'
import DebugImageOverlay from './components/Debug/DebugImageOverlay'
import MainMenuModal from './components/ModalMenu/MainMenuModal'

const App: ParentComponent = (props) => {

  return (
    <div>
      <TheCornerWidget />
      {props.children}
      <Toaster position='bottom-right' />
      <MainMenuModal />
      {DEV && <>
        <DebugImageOverlay />
        <ColorPicker label="Ridge Color" />
      </>}
    </div>
  )
}

export default App
